import { createContext, useEffect, useState } from 'react'
import { SessionTrait } from 'types'
import { getSelectionIndex } from '../../utils/selectionUtils'
import { useExplorerConfig } from './ExplorerConfigProvider'

export interface ISelectionCountsContext {
  selectionCounts: SelectionCount[]
  updateCounts: (selections: SessionTrait[]) => void
}

export interface SelectionCount extends SessionTrait {
  count: number
}

export const SelectionCountsContext = createContext<ISelectionCountsContext>({} as any)

export function SelectionCountsProvider({ children }: { children: React.ReactNode }) {
  const { facility } = useExplorerConfig()
  const [selectionCounts, setSelectionCounts] = useState<SelectionCount[]>([])

  useEffect(() => {
    setSelectionCounts([])
  }, [facility?.id])

  function updateCounts(selections: SessionTrait[]) {
    const newSelectionCounts = selections.reduce((acc, cur) => {
      const index = getSelectionIndex(acc, cur)
      if (index === -1) return [...acc, { ...cur, count: 1 }]
      acc[index].count++
      return acc
    }, selectionCounts)

    setSelectionCounts(newSelectionCounts)
  }

  return (
    <SelectionCountsContext.Provider value={{ selectionCounts, updateCounts }}>
      {children}
    </SelectionCountsContext.Provider>
  )
}
